import { useQuery } from "react-query";
import { queryKeys } from "../../query";
import api, { createURLParams } from "../../client";
import { ChecklistListResponseData } from "../../types/checklist";

export const getData = async (params: ChecklistParams) => {
  const { data } = await api.get<ChecklistListResponseData>(
    `/checklists${createURLParams(params)}`,
  );

  return data;
};

interface ChecklistParams {
  limit?: number;
  offset?: number;
  source?: string;
}

export const useChecklists = (params: ChecklistParams = {}, options = {}) => {
  return useQuery(queryKeys.checklistList(params), () => getData(params), {
    keepPreviousData: true,
    ...options,
  });
};
